var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87022 12.3224C2.80114 12.1152 2.80107 11.8908 2.87003 11.6835C4.25839 7.50975 8.19546 4.50003 12.8355 4.50003C17.4733 4.50003 21.4089 7.50695 22.799 11.6776C22.8681 11.8849 22.8681 12.1093 22.7992 12.3166C21.4108 16.4903 17.4737 19.5 12.8337 19.5C8.19586 19.5 4.26031 16.4931 2.87022 12.3224Z",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8347 12C15.8347 13.6569 14.4915 15 12.8347 15C11.1778 15 9.83467 13.6569 9.83467 12C9.83467 10.3432 11.1778 9.00003 12.8347 9.00003C14.4915 9.00003 15.8347 10.3432 15.8347 12Z",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8a949ca15ea60b579190081b7f5861de.svg";
export { ForwardRef as ReactComponent };